import { useDispatch, useSelector } from 'react-redux';

import { getJourneys, setJourneyAreaDetailsAction, setJourneyCardsAction, setJourneyVideoPlayerAction } from 'features/journeys/redux/slice';

import { ProductJourneyDashboardAreaFullResponse } from './types';
import { ContentVideoPlayer } from 'features/contents';
import { Card } from 'app/types/cards/Card';

const useJourneys = () => {
  const journeys = useSelector(getJourneys);
  const dispatch = useDispatch();

  const setJourneyAreaDetails = (journeyAreaDetails: ProductJourneyDashboardAreaFullResponse) => {
    dispatch(setJourneyAreaDetailsAction(journeyAreaDetails));
  };

  const clearJourneyAreaDetails = () => {
    dispatch(setJourneyAreaDetailsAction(undefined!));
  };

  const setJourneyVideoPlayer = (journeyVideoPlayer: ContentVideoPlayer) => {
    dispatch(setJourneyVideoPlayerAction(journeyVideoPlayer));
  };

  const clearJourneyVideoPlayer = () => {
    dispatch(setJourneyVideoPlayerAction(undefined!));
  };

  const setJourneyCards = (journeyCards: Card[]) => {
    dispatch(setJourneyCardsAction(journeyCards));
  };

  const clearJourneyCards = () => {
    dispatch(setJourneyCardsAction(undefined!));
  };

  return {
    ...journeys,

    setJourneyAreaDetails,
    clearJourneyAreaDetails,

    setJourneyVideoPlayer,
    clearJourneyVideoPlayer,

    setJourneyCards,
    clearJourneyCards,
  };
};

export default useJourneys;
